import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import buildApiUrl from '../config/apiUrlHelper';

const GoogleLoginButton = ({ onSuccess, onError, mode = 'login', iconOnly = false }) => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const isClientConfigured = !!clientId && !clientId.includes('tu_cliente_id_de_google_aqui');

  const handleSuccess = async (credentialResponse) => {
    try {
      // Enviar el token de Google al backend para verificación
      const apiUrl = buildApiUrl('login.php');
      const response = await axios.post(apiUrl, {
        googleToken: credentialResponse.credential,
        mode: mode  // Indicar si es login o registro
      });

      if (response.data.success) {
        onSuccess(response.data.user);
      } else {
        // Si es registro y el usuario ya existe, podría manejarlo diferente
        if (mode === 'register' && response.data.message && response.data.message.includes('existe')) {
          // Si el usuario ya existe durante un registro, podría redirigir a login
          console.log('Usuario ya existe, redirigiendo a login');
        }
        onError(response.data.message || `Error en el ${mode === 'register' ? 'registro' : 'inicio de sesión'} con Google`);
      }
    } catch (error) {
      console.error(`Error en el ${mode === 'register' ? 'registro' : 'inicio de sesión'} con Google:`, error);
      onError(`Error en la autenticación con Google`);
    }
 };

  const handleGoogleSdkError = () => {
    console.error('Error en la autenticación con Google');
    onError('Error en la autenticación con Google');
  };

  if (!isClientConfigured) {
    if (iconOnly) {
      return (
        <button
          type="button"
          onClick={() => onError('Configura REACT_APP_GOOGLE_CLIENT_ID en .env para usar Google')}
          title="Configurar Google OAuth"
          className="inline-flex items-center justify-center bg-transparent p-2 min-h-[44px] min-w-[44px] opacity-40 transition-transform duration-200"
        >
          <span className="sr-only">Configurar Google OAuth</span>
          <svg className="h-7 w-7" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
          </svg>
        </button>
      );
    }

    return (
      <button
        type="button"
        onClick={() => onError('Configura REACT_APP_GOOGLE_CLIENT_ID en .env para usar Google')}
        className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 font-semibold text-slate-700 opacity-60 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100"
      >
        {mode === 'register' ? 'Google no configurado' : 'Google no configurado'}
      </button>
    );
  }

  if (iconOnly) {
    return (
      <GoogleOAuthProvider clientId={clientId}>
        <div className="google-icon-button-wrap">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleGoogleSdkError}
            type="icon"
            theme="outline"
            size="large"
            shape="circle"
          />
        </div>
      </GoogleOAuthProvider>
    );
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="flex w-full justify-center">
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={handleGoogleSdkError}
          type="standard"
          theme="outline"
          size="large"
          text={mode === 'register' ? 'signup_with' : 'signin_with'}
        />
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginButton;
